import React, {useState} from "react";
import {InvoiceGroupBox} from "./InvoiceGroupBox";
import {CodInvoiceTable} from "./CodInvoiceTable";
import {ServiceInvoiceTable} from "./ServiceInvoiceTable";
import {ExpandedWrapper} from "../styles/SubCompanyInvoice.styles";

export const SubCompanyInvoiceDetail = ({detail}) => {
    // Grup kutuları varsayılan açık; yalnızca kullanıcının kapattıkları burada true olarak tutulur
    const [closedGroups, setClosedGroups] = useState({});
    const toggleGroup = groupKey =>
        setClosedGroups(prev => ({...prev, [groupKey]: !prev[groupKey]}));

    const codInvoices = detail?.codReferences || [];
    const serviceInvoices = detail?.serviceInvoices || [];

    return (
        <ExpandedWrapper>
            <InvoiceGroupBox
                variant="cod"
                title="Kesilmesi Beklenen Kapıda Ödeme Tahsilat Faturaları"
                count={codInvoices.length}
                expanded={!closedGroups.cod}
                onToggle={() => toggleGroup("cod")}
            >
                <CodInvoiceTable invoices={codInvoices} />
            </InvoiceGroupBox>
            <InvoiceGroupBox
                variant="service"
                title="Vigo Kurye Hizmeti Faturaları"
                count={serviceInvoices.length}
                expanded={!closedGroups.service}
                onToggle={() => toggleGroup("service")}
            >
                <ServiceInvoiceTable invoices={serviceInvoices} />
            </InvoiceGroupBox>
        </ExpandedWrapper>
    );
};
